import {Component} from '@angular/core';
import {PrimeNgImportsModule} from '../../../../../sdk/src/prime-ng-imports';
import {UserCRUDComponent} from '../../../components/user-crud/user-crud.component';
import {IBasePageComponent} from '../../../../../sdk/src/components/ibase-page/ibase-page.component';

@Component({
    selector: 'app-ga-users-page',
    templateUrl: './users-page.component.html',
    imports: [PrimeNgImportsModule, UserCRUDComponent]
})
export class GUsersPage extends IBasePageComponent {
    /**
     * On ready (Error handling and refresh is done in the parent)
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    protected override async onReady(): Promise<void> {}
    /**
     * On destroy (Error handling and refresh is done in the parent)
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    protected override async onDestroy(): Promise<void> {}
}
